import { Alert, Col, Row, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";

import { ApiPaths } from "@/providers/smarta-banking/banking-api-client";
import { api } from "../../client";
import { SubValue, Td, Value } from "../../../components/styles";
import Copyable from "@/v1/components/common/Copyable";

const getTexts = (t: TFunction) => ({
  bicPrefix: t("institutionCell.bicPrefix"),
  institutionNotFound: t("institutionCell.institutionNotFound"),
});

type Props = {
  institutionId: string;
};

export const InstitutionCell = ({ institutionId }: Props) => {
  const { t } = useTranslation("Banking");
  const texts = getTexts(t);
  const { data: institution, isLoading } = api.useQuery(
    "get",
    ApiPaths.getApiInstitutionsByInstitutionId,
    {
      params: {
        path: {
          institutionId,
        },
      },
    }
  );
  return (
    <Td colSpan={2}>
      {isLoading ? (
        <Skeleton.Input active block size="small" />
      ) : institution?.data ? (
        <Row align="middle" gutter={16} wrap={false}>
          <Col>
            <img
              src={institution.data.logo}
              alt={institution.data.name}
              style={{ width: 32, height: 32, objectFit: "contain" }}
            />
          </Col>
          <Col flex="auto" style={{ minWidth: 0 }}>
            <Value emphasized>{institution.data.name}</Value>
            {institution.data.bic && (
              <SubValue>
                {texts.bicPrefix} <Copyable>{institution.data.bic}</Copyable>
              </SubValue>
            )}
          </Col>
        </Row>
      ) : (
        <Alert message={texts.institutionNotFound} type="error" showIcon />
      )}
    </Td>
  );
};
